import React from "react";
import styles from './PlaneIcon.module.scss';
import LazyImage from 'gui/components/LazyImage/LazyImage';

export interface IPlaneIconProps {
  flip?: boolean;
}

const PlaneIcon = (props: IPlaneIconProps) => (
  <LazyImage
    className={`${styles.PlaneIcon} ${props.flip ? styles.flipped : ''}`.trim()}
    alt="flight direction"
    src="/img/planeRight.svg"
  />
);

PlaneIcon.defaultProps = {};

export default PlaneIcon;
